import { render, staticRenderFns } from "./newSelect.vue?vue&type=template&id=2cb0b83e&scoped=true&"
import script from "./newSelect.vue?vue&type=script&lang=js&"
export * from "./newSelect.vue?vue&type=script&lang=js&"
import style0 from "./newSelect.vue?vue&type=style&index=0&id=2cb0b83e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb0b83e",
  null
  
)

export default component.exports